// extracted by mini-css-extract-plugin
export default {"field":"feeTypeForm_field__r7HRR"};